export const getKeys = (key: string): string[] => [`${key}Title`, `${key}Content`];
